import Pill from '@pelckmans/elementis/components/pill';
import { useTranslation } from 'react-i18next';
import MethodModuleStatus from '../../../components/tooltip/MethodModuleStatus';
import { Method } from '../api/methodsApi';

function MethodStatus({ method, role }: { method: Method; role: string }) {
  const { t } = useTranslation();
  const { id, published } = method;

  const BASE = 'PAGES.CATALOGUE.METHOD.STATUS';

  if (published) return null;

  return (
    <MethodModuleStatus
      id={`review-${id}`}
      tooltipContent={t(`${BASE}.REVIEW.TOOLTIP.VALUE`, { role })}
      pill={
        <Pill prominence="info" role="status" size="sm">
          {t(`${BASE}.REVIEW.LABEL`)}
        </Pill>
      }
    />
  );
}

export default MethodStatus;
